import { cx, styled } from "simplydo/react/styled";

import type { ListProps } from "./List.types";
import { ListItem } from "./ListItem";

const StyledList = styled.ul`
  margin: 0.4em 0;
  padding: 0;
  display: block;
  padding-inline-start: 17px;

  > ${ListItem} {
    list-style-type: none;
  }

  &.is-compact > ${ListItem} {
    padding: 0.25em 0;
  }

  &.is-dashed > ${ListItem} {
    list-style-type: none;

    &::before {
      content: "-";
      display: inline-block;
      width: 0.8em;
      margin-left: -0.8em;
    }
  }

  &.is-bulleted > ${ListItem} {
    list-style-type: disc;
  }

  &.is-ordered {
    counter-reset: ordered;
    list-style-type: decimal;
  }

  &.is-divided > ${ListItem} {
    border-top: 1px solid rgba(34, 36, 38, 0.15);
    &:first-child {
      border-top: none;
    }
  }
`;

const ListComponent = ({
  variant,
  divided,
  compact,
  children,
  className,
  style,
}: ListProps) => {
  const as = variant === "ordered" ? "ol" : "ul";

  return (
    <StyledList
      as={as}
      className={cx(
        variant === "bulleted" && "is-bulleted",
        variant === "ordered" && "is-ordered",
        variant === "dashed" && "is-dashed",
        divided && "is-divided",
        compact && "is-compact",
        className,
      )}
      style={style}
      role={variant === "ordered" ? "list" : undefined}
    >
      {children}
    </StyledList>
  );
};

export const List = styled(ListComponent)``;
